<div class="page-content page-bandi">
    <app-page-title [menuState]="pagetitle" [pageSubtitle]="'bandi_subtitle' | translate"></app-page-title>
    <ng-container *ngIf="piva">
        <ngx-company-tenders #companytenders [serviceendpoint]="serviceendpoint" [detailsMode]="'sidebar'" [piva]="piva" [company]="company"></ngx-company-tenders>
    </ng-container>
</div>

<ng-template #missingpiva>
    <mat-card>
        <mat-card-content>
            <div class="error-message">
                <span class="di di-warning text-danger di-4x">alert</span><div class="h4">Attenzione: partita iva mancante. Contatta l'assistenza per segnalare l'errore</div>
            </div>
        </mat-card-content>
    </mat-card>
   
</ng-template> 
